import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import ErrorBoundary from '../src/components/common/ErrorBoundary';
import './App.scss';
import AuthenticationProvider from './components/hoc/Authentication/AuthenticationProvider';
import AuthorizedUser from './components/hoc/Authentication/AuthorizedUser';
import Main from './Main';
import persistConfig from './redux/persistor';

function App() {
  const clientId = process.env.REACT_APP_CLIENT_ID ? process.env.REACT_APP_CLIENT_ID : '';
  const provider = process.env.REACT_APP_PROVIDER ? process.env.REACT_APP_PROVIDER : '';
  const pathName = window.location.pathname.toLowerCase();
  if (pathName.indexOf('ca') >= 0 || pathName.indexOf('/fa') >= 0) {
    sessionStorage.setItem('REQUESTED_ROLE', pathName.substring(1));
  }
  const tokenEndpoint = process.env.REACT_APP_PROVIDER_TOKEN_ENDPOINT
    ? process.env.REACT_APP_PROVIDER_TOKEN_ENDPOINT
    : '';
  const authorizationEndpoint = process.env.REACT_APP_PROVIDER_AUTH_ENDPOINT
    ? process.env.REACT_APP_PROVIDER_AUTH_ENDPOINT
    : '';
  const redirectUri = window.location.origin;
  const clientSecret = process.env.REACT_APP_CLIENT_SECRET;
  const pingAuthEnabled: boolean = process.env.REACT_APP_PING_AUTH_ENABLED
    ? process.env.REACT_APP_PING_AUTH_ENABLED.toLowerCase() === 'y'
      ? true
      : false
    : true;
  let allowedUserGroups: string[] = process.env.REACT_APP_ALLOWED_USER_GROUP
    ? process.env.REACT_APP_ALLOWED_USER_GROUP.split(',')
    : [];
  const ccPaymentGroup = process.env.REACT_APP_ALLOWED_CC_PAYMENT_GROUP
    ? process.env.REACT_APP_ALLOWED_CC_PAYMENT_GROUP.toLocaleLowerCase()
    : undefined;
  allowedUserGroups = ccPaymentGroup ? [...allowedUserGroups, ccPaymentGroup] : allowedUserGroups;
  const appCode = (
    <Provider store={persistConfig.store}>
      <PersistGate loading={null} persistor={persistConfig.persistor}>
        <Main lang="en" />
      </PersistGate>
    </Provider>
  );
  return (
    <ErrorBoundary>
      {pingAuthEnabled ? (
        <AuthenticationProvider
          clientId={clientId}
          clientSecret={clientSecret}
          provider={provider}
          authorizationEndpoint={authorizationEndpoint}
          tokenEndpoint={`${provider}${tokenEndpoint}`}
          redirectUri={redirectUri}
        >
          <AuthorizedUser allowedUserGroups={allowedUserGroups}>{appCode}</AuthorizedUser>
        </AuthenticationProvider>
      ) : (
        appCode
      )}
    </ErrorBoundary>
  );
}

export default App;
